module.exports = __webpack_public_path__ + "static/dash-2-bbb279e93cb09b03d8cb77c6ba972c84.png";